import { v2 } from '@saucelabs/sl-module-builds';
import { utils as authUtils } from '@saucelabs/sl-container-authentication';

import * as selectors from './selectors';
import { NAMESPACE } from './types';

const META = { skipErrorPage: true };
export const rdcCommonOperations = v2.buildsDetail.operations.createRDCOperations(
  NAMESPACE,
  selectors,
);

export const initialize = (params, meta = META) => (dispatch, getState) => (
  dispatch(rdcCommonOperations.initialize(params, meta))
    .catch(() => {
      const { isAuthenticated, currentPathname } = selectors.authCheckSelector(getState());
      if (!isAuthenticated) {
        authUtils.redirectToMainLogin(currentPathname);
      }
    })
);
